import { Box } from '@mui/material'
import { C1Button, C1ButtonProps } from 'c1ui'
import { Route } from 'lib/routes'
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- C1LinkButton wraps Link
import Link, { LinkProps } from 'next/link'
import { FC, ReactNode } from 'react'

export type C1LinkButtonProps = {
  href: Route;
  nextLinkProps?: Partial<LinkProps>; // scroll, prefetch, replace, etc
  target?: string;
} & C1ButtonProps

export const C1LinkButton: FC<C1LinkButtonProps> = ({ href, nextLinkProps, children, target, ...props }) => {
    if (props.disabled) return <C1Button {...props}>{children}</C1Button>

    const LinkComponent: FC<LinkProps & { children: ReactNode }> = (passedPropsFromMui) => (
        <Link {...nextLinkProps} {...passedPropsFromMui} target={target}>
            {passedPropsFromMui.children}
        </Link>
    )

    return <Box component="span">
        <C1Button href={href} LinkComponent={LinkComponent} {...props}>{children}</C1Button>
    </Box>
}
